export const toPascalCase = (s: string): string =>
  typeof s === 'string' ? s.toLowerCase().replace(/(?:[^\w']|_|^)(\w)/g, (f) => f.toUpperCase()) : s
